'use strict';
const toHotkeyLabel = require('../models/to-hotkey-label');
module.exports = function addHotkey(domElement, hotkey, action) {
	const normalisedHotkeys = hotkey.split(' ').map(c => c.toUpperCase());
	domElement.addEventListener('keydown', evt => {
		if (/INPUT|TEXTAREA/.test(evt.target && evt.target.tagName)) {
			return;
		}
		if (evt.target.hasAttribute('contenteditable')) {
			return;
		}
		if (normalisedHotkeys.includes(toHotkeyLabel(evt))) {
			action(evt);
		}
	});
};
